import {
    DESKTOP_BREAKPOINT,
    getViewportWidth, MOBILE_BREAKPOINT, TABLET_BREAKPOINT_END,
    TABLET_BREAKPOINT_START
} from '../../../domain/animations/animations-provider';

/**
 * in case of loop: get items that are visible by the user
 * type: 'current', 'prev', 'next'
 */
export const getLoopItems = (items: any[], slideItemIndex: number, itemsNumberPerSlide: number, type: string = 'current') => {

    const totalItems = items.length;
    const stateItems: any[] = [];

    let index = slideItemIndex;

    if(type === 'prev'){
        index = getNextPrevSlideItemIndex(slideItemIndex - itemsNumberPerSlide, totalItems, true, 'prev');
    }

    if(type === 'next'){
        index = getNextPrevSlideItemIndex(slideItemIndex + itemsNumberPerSlide, totalItems, true, 'next');
    }

    for(let i=0; i<itemsNumberPerSlide; i++){
        stateItems.push([index, items[index]]);
        const updated = index + 1;
        index = ((updated % totalItems) + totalItems) % totalItems;
    }

    return stateItems;
};

/**
 * get next or prev slide item index
 *
 * in case of looping:
 * const next = getNextPrevSlide(current + 1, total);
 * const prev = getNextPrevSlide(current - 1, total);
 *
 * in not looping and index is out of range ---> return -1
 */
export const getNextPrevSlideItemIndex = (index: number, total:  number, loop: boolean, direction: string) => {
    if(loop){
        const updated = ((index % total) + total) % total;
        return direction === 'prev' ? Math.ceil(updated) : Math.floor(updated);
    }
    return (index < 0 || index >= total) ? -1: index;
};

/**
 * get number of items per slide depending on the viewport
 */
export const getItemsNumberPerSlide = (desktopItemsPerSlide?: number, tableItemsPerSlide?: number, mobileItemsPerSlide?: number) => {
    const vw = getViewportWidth();

    const desktopNum = !isNaN(Number(desktopItemsPerSlide)) ? desktopItemsPerSlide : 5;
    const tableNum = !isNaN(Number(tableItemsPerSlide)) ? tableItemsPerSlide : 2;
    const mobileNum = !isNaN(Number(mobileItemsPerSlide)) ? mobileItemsPerSlide : 2.5;

    if(vw >= DESKTOP_BREAKPOINT){
        return desktopNum;
    }

    if(vw >= TABLET_BREAKPOINT_START){
        return tableNum;
    }

    return mobileNum;
};

/**
 * check if orientation of the gallery is vertical,
 * depending on the provided properties
 */
export const checkIfVertical = (
    isVerticalDesktop: boolean,
    isVerticalTablet: boolean,
    isVerticalMobile: boolean) => {

    const vw = getViewportWidth();

    if(vw <= MOBILE_BREAKPOINT && isVerticalMobile) return true;
    if(vw >= TABLET_BREAKPOINT_START && vw <= TABLET_BREAKPOINT_END && isVerticalTablet) return true;

    return vw >= DESKTOP_BREAKPOINT && isVerticalDesktop;
};

/**
 * define if the buttons should be shown
 */
export const ifShowButtons = (hideButtons?: boolean, showOnMobile?: boolean) => {
    if(hideButtons) return false;
    if(showOnMobile) return true;

    const vw = getViewportWidth();
    return vw >= TABLET_BREAKPOINT_START;
};

/**
 * we assume, that duration provided in settings is the desktop duration
 * calculate duration for the given viewport
 */
export const getDurationPerViewport = (desktopDuration: number) => {
    const vw = getViewportWidth();
    if(vw >= DESKTOP_BREAKPOINT) return desktopDuration;

    return desktopDuration * vw / DESKTOP_BREAKPOINT;
};
